import { Reveal, Chapter } from "../components/Reveal";
import { scrollToId } from "./Nav";

const SLOTS = [
  { id: "01", label: "Founding Practice 01" },
  { id: "02", label: "Founding Practice 02" },
  { id: "03", label: "Founding Practice 03" },
];

export default function CaseStudies() {
  return (
    <section
      id="results"
      data-testid="results-section"
      className="scroll-mt-24 border-t border-ink/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
          <Reveal>
            <Chapter number="07" label="Results" />
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Early results, shared honestly
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-6 text-base leading-relaxed text-ink/70 md:text-lg">
              Leadtochair is new. We don&apos;t have a wall of client logos or
              cherry-picked statistics — and we won&apos;t invent them. As
              founding practices complete their first months, their real
              results will be published here, with their permission.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {SLOTS.map((slot, i) => (
            <Reveal key={slot.id} delay={i * 120} className="h-full">
              <div
                data-testid={`case-study-slot-${i}`}
                className="flex h-full flex-col rounded-2xl border border-dashed border-ink/25 p-8"
              >
                <span className="font-display text-4xl font-medium text-teal/25">{slot.id}</span>
                <h3 className="mt-5 font-medium tracking-wide text-ink/70">{slot.label}</h3>
                <p className="mt-2 text-sm italic leading-relaxed text-ink/50">
                  Case study in progress — real enquiry-to-booking results will
                  appear here once they exist.
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <p className="mt-12 text-center text-sm leading-relaxed text-ink/65 md:text-base">
            Want to be one of the first?{" "}
            <button
              data-testid="results-apply-founding-link"
              onClick={() => scrollToId("contact")}
              className="font-medium text-teal underline decoration-teal/40 underline-offset-4 transition-colors hover:decoration-teal"
            >
              Apply as a Founding Practice
            </button>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
